export { default as RecommendedProductsCarousel } from './RecommendedProductsCarousel';
export type { RecommendedProductsCarouselProps } from './RecommendedProductsCarousel';
